import { render, staticRenderFns } from "./KitaOrSchuleButtons.vue?vue&type=template&id=a09e75ba&scoped=true&"
import script from "./KitaOrSchuleButtons.vue?vue&type=script&lang=js&"
export * from "./KitaOrSchuleButtons.vue?vue&type=script&lang=js&"
import style0 from "./KitaOrSchuleButtons.vue?vue&type=style&index=0&id=a09e75ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09e75ba",
  null
  
)

export default component.exports